import { defineComponent as _defineComponent } from 'vue'
import DocButton from '@/components/ui/buttons/DocButton.vue';
import { useRouter } from '@/heplers/useRouter';
import { useGtm } from '@/heplers/useGtm';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    theme: { default: '' }
  },
  setup(__props: any) {



const router = useRouter();
const { sendGtmEvent } = useGtm();

const sendGtmLogin = () => {
  sendGtmEvent?.({
    event: 'vox_docs_to_login',
    category: 'main_docs',
    action: 'login',
    label: router?.currentRoute?.fullPath,
  });
};

function sendGtmSignup() {
  sendGtmEvent?.({
    event: 'vox_docs_to_signup',
    category: 'main_docs',
    action: 'signup',
    label: router?.currentRoute?.fullPath,
  });
}

return { __sfc: true,router, sendGtmEvent, sendGtmLogin, sendGtmSignup, DocButton }
}

})